import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import { motion } from 'framer-motion';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import {
  BookButtonStyles,
  VideoCardDiv,
  VideoStyles,
  WhatsappHeader, WhatsappNumbersStyles, WhatsappText, WhatsappVideo,
} from './WhatsappPage.styles';
import whatsapp from '../assets/Lottie/whatsapp.json';
import ShinyText from '../common/ShinyText/ShinyText';
import { sendBookDemoData } from '../utils/sendContactData';
import partOne from '../assets/images/partOne.mp4';
import partTwo from '../assets/images/partTwo.mp4';

const schema = yup.object({
  name: yup
    .string()
    .nullable()
    .when('gender', ([gender], schema) => (gender !== 'G'
      ? schema
        .required('Il campo è obbligatorio. Inserisci il nome!')
      : schema)),
  surname: yup
    .string()
    .nullable()
    .when('gender', ([gender], schema) => (gender !== 'G'
      ? schema
        .required('Il campo è obbligatorio. Inserisci il cognome!')
      : schema)),
  email: yup.string().required('La email e un campo obligatorio!'),
  phone: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci numero di telefono!')
    .matches(
      /^[3]{1}[0-9]{8,9}$/,
      'Il numero non e corretto',
    ),
});

function WhatsappPage() {
  const [countOpenRate, setCountOpenRate] = useState(0);
  const [countClickRate, setCountClickRate] = useState(0);
  const [countUtenti, setCountUtenti] = useState(0);
  const [countUserFriendly, setCountUserFriendly] = useState(0);

  const [showInput, setShowInput] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const {
    register, formState: { errors, isSubmitSuccessful }, handleSubmit, reset,
  } = useForm({
    mode: 'all',
    resolver: yupResolver(schema),
    defaultValues: {
      name: '',
      surname: '',
      date_of_birth: '',
      email: '',
      phone: '',
      accept_terms: 0,
      token: '',
      gender: '',
    },
  });

  // const answers = watch();

  const sendData = (data) => {
    sendBookDemoData(data, setLoading, navigate);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCountOpenRate((prevCount) => {
        if (prevCount < 98) {
          return prevCount + 1;
        }
        return prevCount;
      });
    }, 30);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountClickRate((prevCount) => {
        if (prevCount < 60) {
          return prevCount + 1;
        }
        return prevCount;
      });
    }, 50);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountUtenti((prevCount) => {
        if (prevCount < 2.8) {
          const newCount = prevCount + 0.2;
          return parseFloat(newCount.toFixed(1));
        }
        return prevCount;
      });
    }, 200);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountUserFriendly((prevCount) => {
        if (prevCount < 100) {
          return prevCount + 1;
        }
        return prevCount;
      });
    }, 20);

    return () => clearInterval(interval);
  }, []);
  const rightVariant = {
    offscreen: { x: -50, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.3, duration: 1.2 },
    },
  };

  const rightVariantP = {
    offscreen: { x: -50, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.3, duration: 1.4 },
    },
  };

  const rightVariantButton = {
    offscreen: { x: -50, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.5, duration: 1.4 },
    },
  };

  useEffect(() => {
    if (isSubmitSuccessful) {
      reset({
        email: '',
        phone: '',
        accept_terms: 0,
      });
    }
  }, [isSubmitSuccessful, reset]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const leftVariantCard = {
    offscreen: { x: -50, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.3, duration: 0.5 },
    },
  };

  const rightVariantCard = {
    offscreen: { x: 50, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.3, duration: 0.5 },
    },
  };
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Greenia SRL | Servizio Whatsapp</title>
        <meta
          name="description"
          content="Scopri come lavora per te l’AI di Greenia."
        />

        <meta name="apple-mobile-web-app-title" content="Greenia SRL | Servizio Whatsapp" />
        <meta
          name="bingbot"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <meta
          name="twitter:card"
          content="https://greenia.it/images/logo.png"
        />
        <meta
          name="twitter:description"
          content="Scopri come lavora per te l’AI di Greenia."
        />
        <meta name="twitter:title" content="Greenia SRL | Servizio Whatsapp" />
        <meta
          name="twitter:image"
          content="https://greenia.it/images/logo.png"
        />
        <meta property="og:locale" content="it_IT" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Greenia SRL | Servizio Whatsapp" />
        <meta
          property="og:description"
          content="Scopri come lavora per te l’AI di Greenia."
        />
        <meta property="og:image" content="https://greenia.it/logo512.png" />
        <meta property="og:url" content="https://greenia.it/" />
        <meta
          property="og:image:secure_url"
          content="https://greenia.it/images/logo.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:alt" content="Greenia Logo" />
      </Helmet>
      <Navbar />
      <WhatsappHeader>
        <div className="d-flex justify-content-center align-items-start mx-3 mx-lg-0 ms-lg-5 my-5 flex-column">
          <div className="w-75 ms-5">
            <motion.h1
              variants={rightVariant}
              initial="offscreen"
              whileInView="onscreen"
              viewport={{ once: true }}
              className="fs-2z fw-bold"
            >
              Scopri come lavora per te l’AI di Greenia.
            </motion.h1>
            <motion.p
              variants={rightVariantP}
              initial="offscreen"
              whileInView="onscreen"
              viewport={{ once: true }}
              className="mt-4 m-0 fw-light text-muted"
            >
              Prenota una demo gratuita e lasciati guidare in un’esperienza assicurativa completamente nuova: più veloce, più semplice, più vicina a te.

            </motion.p>
            <motion.p
              variants={rightVariantP}
              initial="offscreen"
              whileInView="onscreen"
              viewport={{ once: true }}
              className="mt-1 m-0 fw-light text-muted"
            >
              In pochi minuti vedrai come il nostro sistema su WhatsApp può aiutarti a vendere di più, rispondere meglio e risparmiare tempo ogni giorno.
            </motion.p>
            <motion.p
              variants={rightVariantP}
              initial="offscreen"
              whileInView="onscreen"
              viewport={{ once: true }}
              className="mt-2 m-0 fw-light text-muted"
            >
              Basta un clic. Zero impegno. Massimo impatto.
            </motion.p>
          </div>
          <motion.div
            initial="offscreen"
            whileInView="onscreen"
            variants={rightVariantButton}
            viewport={{ once: true }}
            className="w-75 ms-5"
          >
            {!showInput && (
              <BookButtonStyles>
                <button className="slice shadow " onClick={() => setShowInput(!showInput)}>
                  {/* <p className="text">Piu Informazioni</p> */}
                  <ShinyText text="Book a Demo" disabled={false} speed={3} className="text shiny-text" />
                </button>
              </BookButtonStyles>
            )}
          </motion.div>

          {showInput && (
            <div className="w-75 mt-5 ms-5">
              <form onSubmit={handleSubmit(sendData)}>

                <div className="mb-3">
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    className="form-floating"
                  >
                    <input
                      type="text"
                      {...register('name')}
                      className={`${errors.name ? 'invalid form-control' : 'form-control'} rounded-3 shadow`}
                      name="name"
                      placeholder="Inserisci Nome..."

                    />
                    <label htmlFor="name">Nome</label>
                  </motion.div>
                  <div className={`${errors.name?.message ? 'd-block' : ''} invalid-feedback`}>
                    {errors.name?.message}
                  </div>
                </div>

                <div className="mb-3">
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="form-floating"
                  >
                    <input
                      type="text"
                      {...register('surname')}
                      className={`${errors.surname ? 'invalid form-control' : 'form-control'} rounded-3 shadow`}
                      name="surname"
                      placeholder="Inserisci Cognome..."
                    />
                    <label htmlFor="surname">Cognome</label>
                  </motion.div>
                  <div className={`${errors.surname?.message ? 'd-block' : ''} invalid-feedback`}>
                    {errors.surname?.message}
                  </div>
                </div>

                <div className="mb-3">
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                    className="form-floating"
                  >
                    <input
                      type="email"
                      {...register('email')}
                      className={`${errors.email ? 'invalid form-control' : 'form-control'} rounded-3 shadow`}
                      name="email"
                      placeholder="Indirizzo email..."
                    />
                    <label htmlFor="email">Email</label>
                  </motion.div>
                  <div className={`${errors.email?.message ? 'd-block' : ''} invalid-feedback`}>
                    {errors.email?.message}
                  </div>
                </div>

                <div className="mb-3">
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.4 }}
                    className="form-floating"
                  >
                    <input
                      type="text"
                      {...register('phone')}
                      className={`${errors.phone ? 'invalid form-control form-control-md' : 'form-control form-control-md'} rounded-3 shadow`}
                      name="phone"
                      placeholder="Numero telefono..."
                    />
                    <label htmlFor="phone">Telefono</label>
                  </motion.div>
                  <div className={`${errors.phone?.message ? 'd-block' : ''} invalid-feedback`}>
                    {errors.phone?.message}
                  </div>
                </div>

                <div className="my-3">
                  <motion.button
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                    className="btn btn-success shadow px-5 py-2"
                  >
                    {loading ? 'Inviando dati...' : 'Invia'}

                  </motion.button>
                </div>
              </form>
            </div>
          )}
        </div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="d-none d-md-flex justify-content-end align-items-center"
        >
          <Lottie
            animationData={whatsapp}
            loop
            autoplay
            className="lottie-spotlight"
            style={{
              marginRight: '10%',
            }}
          />

        </motion.div>
      </WhatsappHeader>

      <div className="my-5">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5, ease: 'linear' }}
          viewport={{ once: true }}
          className="fs-1 fw-semibold text-center mt-5"
        >
          Perché Servizio Whatsapp?
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.5, ease: 'linear' }}
          viewport={{ once: true }}
          className="text-muted text-center"
        >

          WhatsApp è l'unica piattaforma che unisce notifiche utili e assistenza clienti!
        </motion.p>
        <WhatsappNumbersStyles className="mt-5 d-flex justify-content-center align-items-center flex-wrap ">
          <div>
            <p className="fs-5 fw-bold text-center m-0">
              {countOpenRate}
              %
            </p>
            <span className="text-muted">Open Rates</span>
          </div>
          <div>
            <p className="fs-5 fw-bold text-center m-0">

              {countClickRate}
              %
            </p>
            <span className="text-muted">Click Rates</span>
          </div>
          <div className="text-center">
            <p className="fs-5 fw-bold text-center m-0">

              {countUtenti}
              Miliardi
            </p>
            <span className="text-muted text-center">Utenti</span>
          </div>
          <div>
            <p className="fs-5 fw-bold text-center m-0">

              {countUserFriendly}
              %

            </p>
            <span className="text-muted">User Friendly</span>
          </div>

        </WhatsappNumbersStyles>
      </div>

      <WhatsappVideo>
        <VideoCardDiv
          variants={leftVariantCard}
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true }}
          className="border p-4 p-lg-5 rounded-3 shadow d-flex align-items-center justify-content-between mx-auto flex-column flex-lg-row"
        >
          <WhatsappText className="pe-5">
            <h4 className="fw-bold mt-3">
              Greenia semplifica il lavoro quotidiano degli intermediari.
            </h4>
            <p className="my-3 m-0 fw-light text-muted">
              Con il servizio AI integrato su WhatsApp, ricevi supporto istantaneo per preventivi, domande frequenti e gestione dei clienti, ovunque ti trovi.
            </p>
            <ul className="green-check-list p-0">
              <li>
                Greenia ti segue ovunque.
              </li>
              <li>
                Greenia ti aiuta subito.
              </li>
              <li>
                Greenia parla come te.
              </li>
              <li>
                Greenia lavora per te.
              </li>
            </ul>
          </WhatsappText>
          <VideoStyles className="row mt-4 mt-lg-0 rounded-3">
            <div className="col-12 d-flex align-items-center justify-content-center p-4 ">
              <video autoPlay muted loop className="rounded-3">
                <source src={partOne} />
              </video>
            </div>
          </VideoStyles>
        </VideoCardDiv>
        <VideoCardDiv
          variants={rightVariantCard}
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true }}
          className="border p-4 p-lg-5 rounded-3 shadow d-flex align-items-center justify-content-between mx-auto flex-column flex-lg-row"
        >
          <WhatsappText className="pe-5">
            <h4 className="fw-bold mt-3">
              Con Greenia, preventivi e gestione polizze diventano immediati.
            </h4>
            <p className="my-3 m-0 fw-light text-muted">
              L’AI su WhatsApp analizza i dati, propone soluzioni e ti assiste anche dopo la vendita, con risposte rapide e sempre aggiornate.
            </p>
            <ul className="green-check-list p-0">
              <li>
                Preventiva in un clic.
              </li>
              <li>
                Rispondi senza perdere tempo.
              </li>
              <li>
                Gestisci tutto da WhatsApp.
              </li>
              <li>
                Fidelizza con semplicità.
              </li>
            </ul>
          </WhatsappText>
          <VideoStyles className="row mt-4 mt-lg-0 rounded-3">
            <div className="col-12 d-flex align-items-center justify-content-center p-4">
              <video autoPlay muted loop className="rounded-3">
                <source src={partTwo} />
              </video>
            </div>
          </VideoStyles>
        </VideoCardDiv>
      </WhatsappVideo>
      <Footer />
    </>
  );
}

export default WhatsappPage;
